import { resendApi } from './resend';
import { verifyApi } from './verify';

export const emailApi = (path: string) => ({
  path,
  resend: () => resendApi(`${path}/resend`),
  verify: () => verifyApi(`${path}/verify`)
});
